<template>
  <div class="gallery-wrapper gallery-wrapper-video">
    <div class="gallery-category">
      <div class="category-tree category-tree-myGallery">
        <el-scrollbar
          wrapStyle="height:550px;overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;"
        >
          <el-tree
            ref="treeVideo"
            empty-text=""
            :data="videoDirList"
            :props="{ children: '_child', label: 'name' }"
            node-key="id"
            :default-expanded-keys="defaultExpandedkeys"
            :indent="10"
            highlight-current
            key="treeVideo"
            @node-click="clickVideoDir"
          >
            <span slot-scope="{ node, data }" class="custom-tree-node">
              <span :title="data.name" class="tree-item-node-name" :class="{ 'tree-node-child': data.id > 0 }">
                <span class="tree-item-name">{{ data.name }}</span>
                <span class="image-num">{{ data.count }}</span>
              </span>
              <span class="more-operations" :class="{ 'is-show-add': data.id == 0 }">
                <span>
                  <el-dropdown @command="handleCommand" trigger="hover" v-if="data.id > 0">
                    <i class="el-icon-more delete-edit-operations"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ type: 'delete', node: node }">删除</el-dropdown-item>
                      <el-dropdown-item :command="{ type: 'rechristen', node: node }">重命名</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
                <span>
                  <el-dropdown @command="handleCommand" trigger="hover" v-if="data.level < 1">
                    <i class="el-icon-plus add-operations"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ type: 'add', node: node }">新建</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
    </div>
    <div class="gallery-main">
      <div class="pictureNew-tit">
        <!-- 添加图片搜索功能 -->
        <div class="searchImg">
          <el-input
            class="search-img"
            clearable
            placeholder="请输入文件名称"
            prefix-icon="el-icon-search"
            v-model="videoName"
            @input="searchVideoResult"
            @keyup.enter.native="searchVideo"
            @clear="emptyVideoSearchResults"
          ></el-input>
        </div>
        <div class="pictureNew-category-add">
          <el-select
            v-model="uploadVideoValue"
            placeholder="上传音视频"
            class="batch-perationData qm-upload__batch-perationData"
            @change="uploadVideo"
          >
            <el-option v-for="item in uploadVideoList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="batchPeration" placeholder="批量操作" class="batch-perationData">
            <el-option v-for="item in batchPerationData" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="image-wrapper">
        <div class="image-list-main">
          <div class="image-list-item">
            <div class="image-operation-panel">
              <div class="select-images-num" v-if="batchPeration">
                <el-checkbox size="mini" class="checkAll" v-model="checkAll" :indeterminate="isIndeterminate">
                  全选
                  <span v-if="selectVideo.length > 0"
                    >已选中
                    <span class="image-operation-panel_num">{{ selectVideo.length }}</span>
                    个</span
                  >
                </el-checkbox>
                <el-button
                  v-if="batchPeration == 1"
                  class="delete-picture"
                  type="text"
                  size="mini"
                  :disabled="!selectVideo.length"
                  @click="deleteSelectVideo"
                  >删除</el-button
                >
                <el-popover v-model="moveTreevisible" placement="right" width="300" trigger="click">
                  <el-tree
                    ref="treeMovePic"
                    empty-text=""
                    :data="videoDirList"
                    :props="{ children: '_child', label: 'name' }"
                    node-key="id"
                    :default-expanded-keys="[0]"
                    :expand-on-click-node="false"
                    :indent="10"
                    highlight-current
                    @node-click="moveVideoToTree"
                  >
                    <span slot-scope="{ node, data }" class="custom-tree-node">
                      <span
                        :title="data.name"
                        class="tree-item-node-name"
                        :class="{ 'tree-node-child': data.id != 0 }"
                        >{{ data.name }}</span
                      >
                    </span>
                  </el-tree>
                  <el-button
                    :disabled="!selectVideo.length"
                    slot="reference"
                    v-show="batchPeration == 2"
                    class="delete-picture"
                    type="text"
                    size="mini"
                    >移动
                  </el-button>
                </el-popover>
                <el-button class="cancel-delete-picture" type="text" size="mini" @click="cancelBatchOperations"
                  >取消</el-button
                >
              </div>
              <span v-else
                >已选中<span class="image-operation-panel_num">{{ selectVideo.length }}</span
                >个</span
              >
            </div>
            <el-scrollbar
              style="height: calc(100% - 36px)"
              wrapStyle="overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;"
              v-loading="videoLoading"
            >
              <div class="image-list">
                <div
                  class="image-item qm-upload-video_item"
                  :class="{ active: checkboxStatus(item.id) }"
                  v-for="(item, index) in videoData.data"
                  :key="`video+${index}`"
                  @click="viewVideoDetail(item)"
                >
                  <div
                    class="image-item-main"
                    :class="{
                      'batch-peration-show-btn': !batchPeration,
                    }"
                    @click="imageCheckboxChange(item)"
                  >
                    <img v-if="item.coverUrl" draggable="false" class="qm-upload-video_image" :src="item.coverUrl" />
                    <img
                      draggable="false"
                      class="qm-upload-video_image"
                      v-else
                      src="https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png"
                      alt=""
                    />
                    <div class="image-title-bg image-title-show">
                      <span class="image-name">
                        {{ item.name }}
                      </span>
                    </div>
                    <div class="image-title-bg image-download-magnify-delete">
                      <i></i>
                      <span>
                        <i class="qm-icon-download" @click.stop="downVideo(item)"></i>
                        <i class="qm-icon-delete" @click.stop="deleteVideo(item)"></i>
                      </span>
                    </div>
                    <span class="state-check" v-if="checkboxStatus(item.id)">
                      <i class="el-icon-check"></i>
                    </span>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="image-operation-page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="paginationChange"
              :current-page.sync="videoData.pageIndex"
              :page-sizes="[20, 40, 60]"
              :page-size="videoData.pageSize"
              layout="prev, pager, next,sizes"
              :total="videoData.total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="image-detail-wrapper qm-upload__detail-wrapper">
          <!-- 图库信息展示 -->
          <pictorial-information
            :imageInfo="videoInfo"
            :isShowMoreImage="isShowMoreImage"
            :selectImages="selectVideo"
            :galleryType="1"
            :galleryShowType="2"
            @saveVideoInfo="saveVideoInfo"
          ></pictorial-information>
          <div class="gallery-control-wrapper" v-if="!batchPeration">
            <el-button type="primary" :disabled="!selectVideo.length" @click="submitSelectVideo">插入</el-button>
          </div>
        </div>
      </div>
    </div>
    <UploadVideoPop
      ref="uploadVideoPop"
      :uploadType="uploadType"
      :currentVideoDir="currentVideoDir"
      @videoUploadedSuccess="videoUploadedSuccess"
      @closeUploadDialog="closeUploadDialog"
    />
    <deltree-pop ref="deltreePop" :delType="2" @delTargetItem="delCategory"></deltree-pop>
  </div>
</template>
<script>
import { stripscript, debounce } from '../utils'
import {
  getVideoCategory,
  getVideoList,
  addVideoCategory,
  delVideoCategoryById,
  getVideoInfo,
  removeVideo,
  editVideoCategoryById,
  moveVideoToCategory,
  delVideoCategoryId,
} from '../api'
import UploadVideoPop from './upload-video-pop.vue'
import PictorialInformation from './pictorial-information.vue'
import DeltreePop from './deltree-pop'

export default {
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 多选时候的数量 0 不限制 只有在multiple 为true的时候生效
    multipleLimit: {
      type: [Number, String],
      default: 0,
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    // 限制视频的大小 0 限制 单位KB
    sizeLimit: {
      type: [Number, String],
      default: 0,
    },

    // 每次调用弹窗的标识符，当前弹窗的类型，处理一个页面多个地方获取组件图片
    imagesType: {
      type: String,
      default: 'video',
    },
    // 允许选择的媒体类型
    mediaTypes: {
      type: [Array, String],
      default: () => ['video'],
    },
  },
  data() {
    return {
      videoName: '', // 视频搜索关键字
      currentVideoDir: {
        id: 0,
        name: '',
        pid: 0,
        level: 0,
      },
      videoDirList: [], // 视频分组列表
      videoData: {
        total: 0,
        pageIndex: 1, // 当前页
        pageSize: 20,
        data: [],
      },
      videoCheck: [], // check列表 用于删除
      selectVideo: [], // 当前选中的视频
      isIndeterminate: false, // 选中部分
      checkAll: false, // 全选
      batchPeration: '',
      defaultExpandedkeys: [0], // 默认展开节点信息
      currentOperatingNode: {}, // 当前操作的节点
      videoLoading: false,
      uploadVideoList: [
        {
          label: '本地上传',
          value: 1,
        },
        {
          label: '音视频路径',
          value: 2,
        },
      ], // 上传视频类型列表
      batchPerationData: [
        {
          label: '批量删除',
          value: 1,
        },
        {
          label: '批量移动',
          value: 2,
        },
      ],
      uploadVideoValue: '', // 当前选中的视频上传类型
      uploadType: 'aliyun',
      videoInfo: null, // 当前视频信息
      moveTreevisible: false, // 移动
    }
  },
  components: {
    UploadVideoPop,
    PictorialInformation,
    DeltreePop,
  },
  watch: {
    visible: {
      handler(n) {
        if (n) {
          this.videoInfo = null
          this._resetSelectVideoStatus()
          // 加载视频
          this.initVideo()
        }
      },
      immediate: true,
    },
    checkAll: function (val) {
      this.isIndeterminate = false
      if (val) {
        const selectVideo = JSON.parse(JSON.stringify(this.videoData.data))
        this.selectVideo = selectVideo
      } else {
        this.selectVideo = []
      }
    },
  },
  computed: {
    checkboxStatus() {
      return function (id) {
        return this.selectVideo.some(item => item.id === id)
      }
    },
    // true显示选中的多张视频 false是显示单张视频信息
    isShowMoreImage() {
      if (this.batchPeration) {
        return false
      } else {
        if (this.selectVideo && this.selectVideo.length > 1) {
          return true
        } else {
          return false
        }
      }
    },
  },
  methods: {
    // 判断是否可以再选择
    _checkMultipleLimit() {
      let multipleLimit = this.multipleLimit
      let multipleStatus = true
      // 如果存在多选限制 并且 等于了当前选中的数量 则返回false
      if (multipleLimit > 0 && this.selectVideo.length === multipleLimit) {
        multipleStatus = false
      }
      return multipleStatus
    },
    _interceptSelectImage(imageInfo) {
      let status = true
      let size = imageInfo.size
      const sizeLimit = Number(this.sizeLimit) * 1024 * 1024
      if (sizeLimit && size > sizeLimit) {
        status = false
        this.$message.error(`请选择${this.sizeLimit}MB大小以下的音视频文件`)
      }
      return status
    },
    // 获取当前视频是否被选中
    _getCurrnetImageIsSelect(id) {
      return this.selectVideo.some(item => item.id === id)
    },
    // 视频的checkbox切换选中状态
    imageCheckboxChange(imageInfo) {
      let selectImage = imageInfo

      if (imageInfo && /\.mp3$/i.test(imageInfo.name) && !this.mediaTypes.includes('audio')) {
        this.$message.error('不允许选择音频文件')
        return
      }
      if (imageInfo && /\.mp4$/i.test(imageInfo.name) && !this.mediaTypes.includes('video')) {
        this.$message.error('不允许选择视频文件')
        return
      }

      if (this.batchPeration) {
        let selectStatus = this._getCurrnetImageIsSelect(selectImage.id)
        if (selectStatus) {
          // 选中了则取消选中
          let index = this.selectVideo.findIndex(item => item.id === selectImage.id)
          if (index > -1) {
            this.selectVideo.splice(index, 1)
          }
        } else {
          // 选中视频前置判断
          let imageStatus = this._interceptSelectImage(imageInfo)
          if (imageStatus) {
            this.selectVideo.push(selectImage)
          }
        }
      } else {
        let selectStatus = this._getCurrnetImageIsSelect(selectImage.id)
        if (this.multiple) {
          // 多选状态
          if (selectStatus) {
            // 选中了则取消选中
            let index = this.selectVideo.findIndex(item => item.id === selectImage.id)
            if (index > -1) {
              this.selectVideo.splice(index, 1)
            }
          } else {
            if (!this._checkMultipleLimit()) {
              // 如果不能选择
              this.$message.error(`最多可以选择${this.multipleLimit}个音视频文件哦`)
              return
            }
            // 如果是选中状态
            // 选中视频前置判断
            let imageStatus = this._interceptSelectImage(imageInfo)
            if (imageStatus) {
              this.selectVideo.push(selectImage)
            }
          }
        } else {
          // 单选状态
          if (selectStatus) {
            this.selectVideo = []
          } else {
            // 选中视频前置判断
            let imageStatus = this._interceptSelectImage(imageInfo)
            if (imageStatus) {
              this.selectVideo = [selectImage]
            }
          }
        }
      }
    },
    // 全选状态判断封装 ----------------------
    setCheckAll() {
      this.videoCheck = []
      this.checkVideoAll = false
      this.isIndeterminate = false
    },
    // 初始化视频 ----------------------
    initVideo() {
      this.currentVideoDir = { id: 0, name: '', pid: 0, level: 0 }
      this.getVideoDir(this.currentVideoDir.id) // 加载视频目录
      this._getVideoList() // 加载视频列表  参数 当前页
    },
    // 加载视频目录 ----------------------
    getVideoDir(currentKey) {
      getVideoCategory().then(res => {
        if (res.status) {
          const { cate, count } = res.data
          this.videoDirList = [
            {
              id: 0,
              name: '根目录',
              pid: 0,
              level: 0,
              count: count,
              _child: cate,
            },
          ]
          this.$nextTick(() => {
            this.$refs.treeVideo && this.$refs.treeVideo.setCurrentKey(currentKey) // 设置当前选中节点为根目录
          })
        }
      })
    },
    // 加载视频列表 ----------------------
    _getVideoList(categoryId = this.currentVideoDir.id) {
      const { pageIndex, pageSize } = this.videoData
      this.videoLoading = true
      const param = {
        category_id: categoryId,
        page: pageIndex,
        page_size: pageSize,
      }
      if (this.videoName) {
        param.keyword = this.videoName
      }
      getVideoList(param).then(res => {
        if (res.status) {
          const _data = []
          res.data.items.forEach(v => {
            _data.push({
              id: v.id,
              videoId: v.play_id,
              playUrl: v.play_url,
              name: v.title,
              coverUrl: v.cover_url,
              createTime: v.created_at,
              description: v.description,
              updateTime: v.updated_at,
              size: v.size,
            })
          })
          this.videoData.data = _data
          this.videoData.total = res.data.total_count
        }
        this.videoLoading = false
      })
    },
    // 视频目录点击事件 ----------------------
    clickVideoDir(v) {
      this.currentVideoDir.id = v.id
      this.currentVideoDir.name = v.name
      this.currentVideoDir.pid = v.pid
      this.currentVideoDir.level = v.level
      if (!this.isShowChoose) {
        this.videoData.pageIndex = 1
        this._getVideoList()
      }
    },
    // 处理图片目录更新 展示当前节点目录
    getDefaultExpandedkeys(parent) {
      const key = parent.key
      if (!key) {
        this.defaultExpandedkeys = [0]
      } else {
        this.defaultExpandedkeys = [0, key]
      }
    },
    // 新建目录 编辑目录
    handleCommand(command) {
      const { node, type } = command
      const { data } = node
      this.currentOperatingNode = node
      if (type === 'delete') {
        this.$refs.deltreePop.openDialog()
        // this.delVideoCategory()
      } else if (type === 'add') {
        // 新增
        this.$prompt('', '新建目录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '请输入目录名称',
        })
          .then(({ value }) => {
            const name = stripscript(value)
            this.saveVideoAdd(name)
          })
          .catch(() => {})
      } else {
        // 重命名
        this.$prompt('', '重命名', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '请输入目录名称',
          inputValue: data.name,
        })
          .then(({ value }) => {
            const name = stripscript(value)
            this.saveVideoEdit(name)
          })
          .catch(() => {})
      }
    },
    // 修改视频分组弹框 - 保存事件 ----------------------
    saveVideoEdit(name) {
      const { data } = this.currentOperatingNode
      if (name.length) {
        editVideoCategoryById(data.id, name).then(res => {
          if (res.status) {
            this.$message.success('目录名称修改成功')
            this.getDefaultExpandedkeys(this.currentOperatingNode)
            this.getVideoDir(this.currentVideoDir.id)
          }
        })
      } else {
        this.$message.warning('请输入目录名称!')
      }
    },
    // 删除当前目录
    delCategory(operationType) {
      const { key, parent } = this.currentOperatingNode
      const data = {
        type: operationType,
        id: key,
      }
      delVideoCategoryId(data).then(res => {
        if (res) {
          if (res.status) {
            this.$message.success(res.message)
            if (operationType === 1) {
              this.$message.success('目录删除成功')
            } else {
              this.$message.success('目录及文件删除成功')
            }
            this.$refs.deltreePop.closeDialog()
            this.currentPage = 1
            this.getDefaultExpandedkeys(parent)
            if (this.currentVideoDir.id === key) {
              this.getVideoDir(0)
              this._getVideoList(0)
            } else {
              this.getVideoDir(this.currentVideoDir.id)
              this._getVideoList(this.currentVideoDir.id)
            }
          } else {
            this.$message.error(res.message)
          }
        } else {
          this.$message.error('系统异常，请稍后重试。')
        }
      })
    },
    // 添加视频分组弹框-保存事件 ----------------------
    saveVideoAdd(name) {
      if (name.length === 0) {
        this.$message({
          message: '请输入分组名称!',
          type: 'warning',
        })
        return
      }
      const { key } = this.currentOperatingNode
      addVideoCategory(key, name).then(res => {
        if (res.status) {
          this.$message.success('分组添加成功')
          //  修改本地目录数据
          this.getDefaultExpandedkeys(this.currentOperatingNode)
          this.getVideoDir()
        }
      })
    },
    // 删除当前视频分组 ----------------------
    delVideoCategory() {
      const { key, parent } = this.currentOperatingNode
      delVideoCategoryById(key).then(res => {
        if (res) {
          if (res.status) {
            this.$message.success('分组删除成功')
            this.getDefaultExpandedkeys(parent)
            if (this.currentVideoDir.id === key) {
              this.getVideoDir(0)
              this._getVideoList(0)
            } else {
              this.getVideoDir(this.currentVideoDir.id)
              this._getVideoList()
            }
          }
        }
      })
    },
    // 通过关键字 搜索图片
    searchVideoResult() {
      this.videoData.pageIndex = 1
      this._getVideoList()
    },
    // 清空关键字 搜索图片
    emptyVideoSearchResults() {
      this.videoName = ''
      this.videoData.pageIndex = 1
      this._getVideoList()
    },
    // input输入事件 触发函数
    searchVideo() {
      debounce(() => {
        this._getVideoList()
      }, 500)()
    },
    // 视频列表条数改变
    handleSizeChange(val) {
      this.videoData.pageSize = val
      this._getVideoList()
    },
    // 视频列表切换
    paginationChange(currentPage) {
      this.videoData.currentPage = currentPage
      this._getVideoList()
    },
    // 点击视频上传
    uploadVideo() {
      if (this.uploadVideoValue === 1) {
        this.uploadType = 'aliyun'
        this.$refs.uploadVideoPop.show()
      } else {
        this.uploadType = 'url'
        this.$refs.uploadVideoPop.show()
      }
    },
    // 视频上传成功后处理
    videoUploadedSuccess() {
      this._getVideoList()
    },
    // 弹窗关闭封装
    closeUploadDialog() {
      this.uploadVideoValue = ''
    },
    // 查看视频详情
    viewVideoDetail(videoInfo) {
      const { selectVideo } = this
      if (selectVideo && selectVideo.length === 0) {
        this.videoInfo = null
        return
      } else if (selectVideo.length === 1) {
        videoInfo = selectVideo[0]
      }
      this.videoInfo = {
        id: videoInfo.id,
        videoId: videoInfo.videoId,
        path: videoInfo.playUrl,
        coverUrl:
          videoInfo.coverUrl || 'https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png',
        nameType: videoInfo.name && videoInfo.name.split('.')[1],
        partName: videoInfo.name && videoInfo.name.split('.')[0],
        name: videoInfo.name,
        size: videoInfo.size,
        createTime: videoInfo.createTime,
        updateTime: videoInfo.updateTime,
        description: videoInfo.description,
        isShowPictureName: false, // 编辑图片
        isShowDescription: false, // 编辑备注
      }
    },
    // 更新视频列表 视频信息
    saveVideoInfo(videoInfo) {
      for (const v of this.videoData.data) {
        if (v.id === videoInfo.id) {
          v.name = videoInfo.name
          v.description = videoInfo.description
          break
        }
      }
    },
    // 取消批量操作
    cancelBatchOperations() {
      this.batchPeration = ''
      this.selectVideo = []
    },
    // 删除单个视频
    deleteVideo(item) {
      const ids = [item.id]
      this.delVideos(ids)
    },
    // 批量删除视频
    deleteSelectVideo() {
      const ids = this.selectVideo.map(d => d.id)
      this.delVideos(ids)
    },
    // 批量删除视频 ----------------------
    delVideos(ids) {
      try {
        this.$confirm('此操作将永久删除该音视频文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.videoLoading = true
            removeVideo(ids).then(res => {
              if (res.status) {
                this.$message.success('删除成功')
                this._getVideoList() // 加载视频列表
                this.currentPage = 1
                this.batchPeration = ''
                this.selectVideo = []
                if (this.videoInfo && ids.includes(this.videoInfo.id)) {
                  this.videoInfo = null
                }
                this.videoLoading = false
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            })
          })
      } catch (e) {}
    },
    // 图片批量移动到指定目录
    moveVideoToTree(v, nodeData) {
      this.getDefaultExpandedkeys(nodeData.parent)
      const ids = this.selectVideo.map(item => item.id)
      const { id } = v
      const data = {
        ids,
        category_id: id,
      }
      moveVideoToCategory(data).then(res => {
        if (res.status) {
          this.moveTreevisible = false
          this._resetSelectVideoStatus()
          this.batchPeration = ''
          this.videoInfo = null
          this.$message.success('移动成功')
          this.getVideoDir(id)
          this._getVideoList(id)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 调用点击按钮 实现mp4格式视频下载
    downVideo(item) {
      let { playUrl, videoId, name } = item
      if (playUrl) {
        // 网络视频
        this.downCurrentVideo(playUrl, name)
      } else if (videoId && playUrl) {
        // 阿里云视频 已有播放地址
        this.downCurrentVideo(playUrl, name)
      } else {
        // 阿里云视频 获取播放地址后插入
        getVideoInfo(videoId).then(res => {
          if (res.status) {
            const { FileURL } = res.data && res.data.Mezzanine
            this.downCurrentVideo(FileURL, name)
          }
        })
      }
    },
    downCurrentVideo(playUrl, name) {
      var xhr = new XMLHttpRequest()
      xhr.open('GET', playUrl, true)
      xhr.responseType = 'arraybuffer' // 返回类型blob
      xhr.onload = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let blob = this.response
          // 转换一个blob链接
          const mimeType = name && name.toLowerCase().endsWith('mp3') ? 'audio/mpeg' : 'video/mp4'
          let u = window.URL.createObjectURL(new Blob([blob], { type: mimeType }))
          let a = document.createElement('a')
          a.download = name
          a.href = u
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          a.remove()
        }
      }
      xhr.send()
    },
    // 重置视频的选中状态
    _resetSelectVideoStatus() {
      this.selectVideo = []
    },
    // 插入视频的图片
    submitSelectVideo() {
      const { selectVideo } = this
      const selectVideoData = []
      selectVideo &&
        selectVideo.forEach(el => {
          let { playUrl, coverUrl, videoId } = el
          if (playUrl) {
            // 网络视频
            coverUrl = 'https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png'
            selectVideoData.push({
              playUrl,
              coverUrl,
            })
          } else if (videoId && playUrl) {
            // 阿里云视频 已有播放地址
            selectVideoData.push({
              playUrl,
              coverUrl,
            })
          } else {
            // 阿里云视频 获取播放地址后插入
            getVideoInfo(videoId).then(res => {
              if (res.status) {
                const { FileURL } = res.data && res.data.Mezzanine
                selectVideoData.push({
                  playUrl: FileURL,
                  coverUrl,
                })
              }
            })
          }
        })
      setTimeout(() => {
        if (this.multiple) {
          // 如果多选
          this.$emit('changeSelectVideo', selectVideoData, this.imagesType)
        } else {
          // 如果单选
          this.$emit('changeSelectVideo', selectVideoData[0], this.imagesType)
        }
        this._resetSelectVideoStatus()
      }, 1000)
    },
  },
}
</script>
<style scoped></style>
